import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { apiHostname } from 'shared/constants';
import { AlphamartHttpError, SuccessResponse } from 'shared/types';
import { getHttpClient } from 'shared/utils/httpClient';

export enum ApiTokenKeys {
  GenerateApiToken = 'GenerateApiToken',
  RevokeApiToken = 'RevokeApiToken',
}

interface GenerateApiTokenParams {
  userId: number;
}

interface GenerateApiTokenResponse {
  token: string;
  createdAt: string;
}

export const useGenerateApiToken = (
  options?: UseMutationOptions<
    GenerateApiTokenResponse,
    AlphamartHttpError,
    GenerateApiTokenParams
  >,
) =>
  useMutation<GenerateApiTokenResponse, AlphamartHttpError, GenerateApiTokenParams, unknown>(
    async (params: GenerateApiTokenParams) => {
      const response = await getHttpClient().post<GenerateApiTokenResponse>(
        `${apiHostname}/api/users/${params.userId}/api-token`,
      );

      return response.data;
    },
    { mutationKey: [ApiTokenKeys.GenerateApiToken], ...options },
  );

interface RevokeApiTokenParams {
  userId: number;
}

export const useRevokeApiToken = (
  options?: UseMutationOptions<SuccessResponse, AlphamartHttpError, RevokeApiTokenParams>,
) =>
  useMutation<SuccessResponse, AlphamartHttpError, RevokeApiTokenParams, unknown>(
    async (params: RevokeApiTokenParams) => {
      const response = await getHttpClient().delete<SuccessResponse>(
        `${apiHostname}/api/users/${params.userId}/api-token`,
      );

      return response.data;
    },
    { mutationKey: [ApiTokenKeys.RevokeApiToken], ...options },
  );
